<template>
  <fieldset class="text-center my-24 lg:mt-48">
    <legend class="sr-only">How many years of paid child care experience do you have?</legend>
    <poppins-counter ref="counter" v-model="yearsExperience" label="years" :min="0" :max="50" />
  </fieldset>
</template>

<script lang="ts">
import { mapActions, mapGetters, mapState } from 'vuex';
import PoppinsCounter from '@/components/counter/PoppinsCounter.vue';

export default {
  name: 'YearsExperienceStep',
  components: {
    PoppinsCounter,
  },
  computed: {
    ...mapState(['careType']),
    ...mapGetters(['getFormField']),
    yearsExperience: {
      get() {
        if (this.getFormField('yearsExperience') === null) this.updateForm({ key: 'yearsExperience', value: 0 });
        return this.getFormField('yearsExperience') || 0;
      },
      set(newValue) {
        return this.updateForm({ key: 'yearsExperience', value: newValue });
      },
    },
  },
  methods: {
    ...mapActions(['updateForm']),
  },
};
</script>
